import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresAnaliseService } from "../services/indicadores-analise.service";


@Injectable({
  providedIn: 'root'
})
export class IndicadoresAnaliseResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresAnaliseService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresAnaliseListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresAnaliseService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByListForm();
  }
}